(function(){
    /** @ngInject */
    function customSuccessCtrl($scope, $state){
        if(typeof(window.top) !== 'undefined')
            window.top.postMessage('scrollTop', "*");
        $scope.today_date = moment.tgz().format('MMM D, YYYY HH:mm');
        $scope.$on("$viewContentLoaded", function() {
            updateWidgetStep('Custom-Request-Completed');
        });
    }
    angular.module("Waiteraid").controller("customSuccessCtrl", customSuccessCtrl);
})();
